import {NetworkError} from './network-error';
import {HttpErrorResponse} from '@angular/common/http';

export class UnavailableEndpointError extends NetworkError {
    constructor(httpError: HttpErrorResponse) {
        super(`[UnAvailableEndpointError] ${httpError.message}`, httpError);
    }

    isCritical() {
        return true;
    }
}
